<template>
  <div>
    <el-header ref="header"  style="height: auto;margin-bottom: 10px">
      <el-form  :inline="true" :model="searchForm" ref="searchFormRef" class="demo-form-inline">
          <el-form-item label="" prop="name" >
            <el-input placeholder="请输入联系人姓名" v-model="searchForm.name"   @keydown.enter.native="handleSearchBtn"/>
          </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="handleSearchBtn" icon="el-icon-search">搜索</el-button>
        </el-form-item>
      </el-form>
    </el-header>
    <el-table
      border
      :data="data"
      highlight-current-row
      @row-click="handleRowClick"
    >
      <el-table-column prop="cid" label="CID" />
      <el-table-column prop="name" label="姓名" />
      <el-table-column prop="bumen" label="部门" />
      <el-table-column prop="tel" label="电话" />
      <el-table-column prop="phone" label="手机" />
      <el-table-column prop="max" label="传真" />
      <el-table-column prop="email" label="邮箱" />
    </el-table>
<!--    <el-pagination @size-change="pageSizeChange" @current-change="pageCurrentChange"-->
<!--                   :current-page="selectPage.pageNum" :page-sizes="[20, 50, 100, 200]"-->
<!--                   :page-size="selectPage.pageSize"-->
<!--                   background-->
<!--                   layout="total, sizes, prev, pager, next, jumper" :total="allNum"-->
<!--                   style="margin-top: 14px;margin-bottom:14px"-->
<!--    >-->
<!--    </el-pagination>-->
  </div>
</template>
<script>
import { defineComponent, reactive, ref,watch,toRefs } from '@vue/composition-api'
import request from '@/utils/request'
export default defineComponent({
  components: {},
  props:{
    contractId: {
      type:  [Number,String],
      default: ''
    },
    showContacts: {
      type: Boolean,
      default: false
    },
    flag: {
      type: Boolean,
      default: false
    }
  },
  setup(props,{emit}) {
    const selectedContact = reactive({
      name: '',
      phone: ''
    })
    const searchFormRef = ref(null)
    const searchForm = reactive({
      name: '',
    })
    const selectPage = reactive({
      pageNum: 1,
      pageSize: 20
    })
    const allNum = ref(1)
    const data = ref([])


    // 选择联系人
    const handleRowClick = (row) => {
      selectedContact.name = row.name
      selectedContact.phone = row.phone
      emit('childContact', selectedContact)
      emit('quotationContact', row)
    }

    const getContract = (val) => {
      newContractId.value = val
      request({
        url: 'lxrdata.yy',
        method: 'post',
        data: { cid: newContractId.value, ...searchForm }
      }).then(res => {
        if (res.code == 200) {
          data.value = res.lxrdata
          if (data.value.length > 0) {
            emit('getFirstContact', data.value[0])
          } else {
            emit('getFirstContact', data.value)
          }
        }
      })
    }

    const newContractId = ref('')
    const handleSearchBtn = () => {
      getContract(newContractId.value);
    }


    //客户信息-客户合同-出库单-联系人请求
    watch(()=>props.contractId,(val)=>{
      if(val) {
        getContract(val)
        newContractId.value = val
      }
    },{deep:true,immediate:true})


    return{
      newContractId,
      data,
      selectedContact,
      selectPage,
      allNum,
      searchFormRef,
      searchForm,
      getContract,
      handleSearchBtn,
      handleRowClick,
    }
  }
})
</script>
<style lang="scss" scoped>
.customer-table {
  margin: 0 10px;
}
.el-header {
  padding: 0;
}
</style>
